import React from 'react';

const SEGMENT_COLORS = ['#FF4D2E', '#D9A441', '#FF4D2E', '#17140F', '#FF4D2E', '#D9A441'];

export const DummyQR = ({ size = 26 }) => (
  <svg viewBox="0 0 21 21" width={size} height={size} style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="7" height="7" fill="#17140F"/>
    <rect x="1" y="1" width="5" height="5" fill="white"/>
    <rect x="2" y="2" width="3" height="3" fill="#17140F"/>
    <rect x="14" y="0" width="7" height="7" fill="#17140F"/>
    <rect x="15" y="1" width="5" height="5" fill="white"/>
    <rect x="16" y="2" width="3" height="3" fill="#17140F"/>
    <rect x="0" y="14" width="7" height="7" fill="#17140F"/>
    <rect x="1" y="15" width="5" height="5" fill="white"/>
    <rect x="2" y="16" width="3" height="3" fill="#17140F"/>
    <rect x="8"  y="0"  width="1" height="1" fill="#17140F"/>
    <rect x="10" y="0"  width="2" height="1" fill="#17140F"/>
    <rect x="9"  y="2"  width="1" height="1" fill="#17140F"/>
    <rect x="11" y="1"  width="2" height="1" fill="#17140F"/>
    <rect x="8"  y="3"  width="2" height="1" fill="#17140F"/>
    <rect x="12" y="3"  width="1" height="1" fill="#17140F"/>
    <rect x="7"  y="8"  width="2" height="1" fill="#17140F"/>
    <rect x="11" y="8"  width="2" height="1" fill="#17140F"/>
    <rect x="8"  y="9"  width="3" height="2" fill="#17140F"/>
    <rect x="13" y="9"  width="1" height="1" fill="#17140F"/>
    <rect x="7"  y="11" width="2" height="1" fill="#17140F"/>
    <rect x="11" y="11" width="1" height="1" fill="#17140F"/>
    <rect x="10" y="12" width="3" height="1" fill="#17140F"/>
    <rect x="8"  y="13" width="1" height="1" fill="#17140F"/>
    <rect x="9"  y="14" width="1" height="1" fill="#17140F"/>
    <rect x="11" y="14" width="2" height="1" fill="#17140F"/>
    <rect x="8"  y="16" width="1" height="1" fill="#17140F"/>
    <rect x="12" y="15" width="2" height="1" fill="#17140F"/>
    <rect x="9"  y="17" width="2" height="1" fill="#17140F"/>
    <rect x="12" y="17" width="1" height="1" fill="#17140F"/>
    <rect x="14" y="8"  width="1" height="1" fill="#17140F"/>
    <rect x="16" y="8"  width="3" height="1" fill="#17140F"/>
    <rect x="15" y="9"  width="2" height="1" fill="#17140F"/>
    <rect x="20" y="9"  width="1" height="1" fill="#17140F"/>
    <rect x="14" y="10" width="2" height="1" fill="#17140F"/>
    <rect x="18" y="10" width="2" height="1" fill="#17140F"/>
    <rect x="16" y="11" width="1" height="1" fill="#17140F"/>
    <rect x="19" y="12" width="1" height="1" fill="#17140F"/>
    <rect x="15" y="13" width="3" height="1" fill="#17140F"/>
  </svg>
);

// Raffle-wheel brand mark: alternating ember/gold segments on an ink ring,
// a QR glyph at the hub — evokes a game-show prize wheel, not a candy pinwheel.
const SpinLogo = ({ size = 64 }) => {
  const innerSize = Math.round(size * 0.55);
  const qrSize = Math.round(innerSize * 0.62);
  const segAngle = 360 / SEGMENT_COLORS.length;

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      background: `conic-gradient(${SEGMENT_COLORS.map((c, i) => `${c} ${i * segAngle}deg ${(i + 1) * segAngle}deg`).join(', ')})`,
      boxShadow: `0 6px 16px rgba(23,20,15,0.25), inset 0 0 0 2px ${'#17140F'}`,
      animation: 'slow-spin 22s linear infinite',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        width: innerSize, height: innerSize, borderRadius: '50%', background: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: 'counter-spin 22s linear infinite',
        boxShadow: 'inset 0 0 0 2px rgba(23,20,15,0.15)',
      }}>
        <DummyQR size={qrSize} />
      </div>
    </div>
  );
};

export default SpinLogo;
